import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { Selection } from 'src/domains/sportsbook/webview/components/Selection';

import { withConfig } from 'src/withConfig';



const setEventRowSelections = (variant: DefaultComponentVariantType | null, theme: EmotionTheme ): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            flex: 1 1 33.3334%;

            display: flex;

            flex-flow: column nowrap;

            gap: ${theme.star.gap.small};

            min-width: 0;

        `;

    }

    return css`

        flex: 1 0 33.3334%;

    `;

};



interface EventRowSelectionsPropsType {

    variant: DefaultComponentVariantType | null;

}



export const EventRowSelections = withConfig(theme => styled('div', { label: 'EventRowSelections' })<EventRowSelectionsPropsType>`

    ${({ variant }): SerializedStyles => setEventRowSelections(variant, theme)}

`);



export const EventRowSelectionsName = withConfig(theme => styled('div', { label: 'EventRowSelectionsName' })<EventRowSelectionsPropsType>`

    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};

    background-color: ${theme.star.eventRow.bgColorSecondary};

    color: ${theme.star.eventRow.txtColor};

    font-size: ${theme.star.fontSize.xSmall};

    font-weight: ${theme.star.fontWeight.xMedium};

    height: 20px;

    line-height: 1.2;

    padding: 4px 8px;

    text-align: center;

    @media ${theme.star.mediaQuery.desktop} {

        display: none;

    }

`);



export const EventRowSelectionsElement = withConfig(theme => styled('div', { label: 'EventRowSelectionsElement' })<EventRowSelectionsPropsType>`

    display: flex;

    height: 48px;

    @media ${theme.star.mediaQuery.desktop} {

        margin-left: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '0' : '1px'};

        width: 100%;

    }

`);



export const EventRowSingleSelection = styled(Selection, { label: 'EventRowSingleSelection' })`

    flex: 1 1 100%;

    height: 100%;

    width: 100%;

`;

